import React from 'react'

import PropTypes from 'prop-types'

import ActivityDetailsTab from '../ActivityDetailsTab'

const ActivityDetails = ({
  columns = [],
  departments = [],
  activity = null,
  currentColumn = null,
  isMultiDepartment = false,
  isShow = false,
}) => {
  return (
    <ActivityDetailsTab
      columns={columns}
      departments={departments}
      activity={activity}
      currentColumn={currentColumn}
      isMultiDepartment={isMultiDepartment}
      isShow={isShow}
    />
  )
}

ActivityDetails.propTypes = {
  columns: PropTypes.array,
  departments: PropTypes.array,
  activity: PropTypes.object,
  currentColumn: PropTypes.object,
  isMultiDepartment: PropTypes.bool,
  isShow: PropTypes.bool,
}

export default ActivityDetails
